import CryptoJS from "crypto-js";

class SecureSessionStorage {
  constructor(storage = window.sessionStorage) {
    this.storage = storage;
    this.secretKey = process.env.REACT_APP_ENCRYPT_STORAGE_SECRET;
  }

  setItem(key, value) {
    const stringValue = JSON.stringify(value);

    const encrypted = CryptoJS.AES.encrypt(
      stringValue,
      this.secretKey
    ).toString();

    this.storage.setItem(key, encrypted);
  }

  getItem(key) {
    const encrypted = this.storage.getItem(key);
    if (!encrypted) return null;

    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, this.secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      return JSON.parse(decrypted);
    } catch (err) {
      console.error("Decryption failed", err);
      return null;
    }
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }
}

export default SecureSessionStorage;